import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { not } from 'ember-truth-helpers';

interface GeneralDropdownsTriggersTriggerDropdownBasicSignature {
  Args: {
    isOpen: boolean;
    selected: string;
    toggleDropdown: () => void;
  };
  Element: HTMLDivElement;
}

const GeneralDropdownsTriggersTriggerDropdownBasic = <template>
  {{! template-lint-disable require-presentational-children }}
  <div
    class="select-wrapper left-column prism-dropdown-trigger picker month-selection-trigger
      {{if @isOpen 'open'}}"
    data-event-id="datepicker-toggle-dropdown"
    data-event-value={{not @isOpen}}
    data-test-id="trigger-dropdown-basic"
    role="button"
    {{on "click" @toggleDropdown}}
    ...attributes
  >
    <div class="trigger__content gap-100">
      <span>
        {{@selected}}
      </span>
      <PrismIcon
        @name={{if @isOpen "chevron-up" "chevron-down"}}
        @size="small"
      />
    </div>
  </div>
</template> satisfies TOC<GeneralDropdownsTriggersTriggerDropdownBasicSignature>;
export default GeneralDropdownsTriggersTriggerDropdownBasic;
